module.exports = __webpack_public_path__ + "img/full7-min.952f67f1.png";